import script from "./UDropDownHours.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDropDownHours.vue?vue&type=script&setup=true&lang=ts"

import "./UDropDownHours.vue?vue&type=style&index=0&id=465ec8aa&lang=css"

const __exports__ = script;

export default __exports__